/**
 * Idioma de los componentes compartidos. El portal no lo toca y queda en español; la tienda lo cambia con
 * fijarIdiomaCompartido() cuando la persona elige otro idioma (hoy solo en la demostración).
 */
export type IdiomaUI = 'es' | 'en'

const TEXTOS = {
  es: {
    locale: 'es-MX',
    passwordCorta: 'La contraseña debe tener al menos 10 caracteres.',
    passwordMezcla: 'Incluye al menos una minúscula, una mayúscula y un número.',
    ocultar: 'Ocultar contraseña',
    mostrar: 'Mostrar contraseña',
    sinConfirmar: 'Confirma tu correo con el enlace que te enviamos y vuelve a ingresar.',
    demasiados: 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.',
    credenciales: 'El correo o la contraseña no son correctos.',
    yaExiste: 'Ya hay una cuenta con ese correo. Ingresa, o recupera tu contraseña si no la recuerdas.',
    debil: 'La contraseña es muy débil. Usa 10 o más caracteres con mayúscula, minúscula y número.',
    noCreada: 'No pudimos crear la cuenta. Inténtalo de nuevo.',
    confirmar: 'Te enviamos un correo para confirmar tu cuenta. Ábrelo y después ingresa con tu contraseña.',
    noEnviado: 'No pudimos enviar el correo. Espera unos minutos e inténtalo de nuevo.',
    enlaceEnviado: 'Si el correo tiene una cuenta, te enviamos un enlace para elegir una contraseña nueva. Puede tardar un par de minutos; revisa también el spam.',
    ingresar: 'Ingresar',
    crearCuenta: 'Crear cuenta',
    enviarEnlace: 'Enviar enlace',
    volverIngresar: 'Volver a ingresar',
    correo: 'Correo',
    password: 'Contraseña',
    ayudaPassword: 'Mínimo 10 caracteres, con mayúscula, minúscula y número.',
    unMomento: 'Un momento…',
    olvide: 'Olvidé mi contraseña',
    crearUna: 'Crear una cuenta',
    yaTengo: 'Ya tengo cuenta',
    noCoinciden: 'Las contraseñas no coinciden.',
    distinta: 'Elige una contraseña distinta de la anterior.',
    noGuardada: 'No pudimos guardar la contraseña. Pide un enlace nuevo e inténtalo otra vez.',
    nueva: 'Contraseña nueva',
    repetir: 'Repite la contraseña',
    guardando: 'Guardando…',
    guardar: 'Guardar contraseña',
    precioOculto: 'Precio visible al verificar tu empresa',
    iva0: 'IVA 0 %',
    masIva: (p: number) => `+ IVA ${p} %`,
    lote: 'Lote',
    caducidad: 'Caducidad',
    caducado: 'Caducado',
    caducaPronto: 'Caduca pronto',
  },
  en: {
    locale: 'en-US',
    passwordCorta: 'Your password must be at least 10 characters long.',
    passwordMezcla: 'Include at least one lowercase letter, one uppercase letter and one number.',
    ocultar: 'Hide password',
    mostrar: 'Show password',
    sinConfirmar: 'Confirm your email with the link we sent you, then sign in again.',
    demasiados: 'Too many attempts. Wait a few minutes and try again.',
    credenciales: 'The email or password is incorrect.',
    yaExiste: 'An account with that email already exists. Sign in, or reset your password if you forgot it.',
    debil: 'That password is too weak. Use 10 or more characters with uppercase, lowercase and a number.',
    noCreada: 'We couldn’t create your account. Please try again.',
    confirmar: 'We sent you an email to confirm your account. Open it, then sign in with your password.',
    noEnviado: 'We couldn’t send the email. Wait a few minutes and try again.',
    enlaceEnviado: 'If that email has an account, we sent a link to choose a new password. It can take a couple of minutes; check your spam folder too.',
    ingresar: 'Sign in',
    crearCuenta: 'Create account',
    enviarEnlace: 'Send link',
    volverIngresar: 'Back to sign in',
    correo: 'Email',
    password: 'Password',
    ayudaPassword: 'At least 10 characters, with uppercase, lowercase and a number.',
    unMomento: 'One moment…',
    olvide: 'I forgot my password',
    crearUna: 'Create an account',
    yaTengo: 'I already have an account',
    noCoinciden: 'The passwords don’t match.',
    distinta: 'Choose a password different from your previous one.',
    noGuardada: 'We couldn’t save your password. Request a new link and try again.',
    nueva: 'New password',
    repetir: 'Repeat your password',
    guardando: 'Saving…',
    guardar: 'Save password',
    precioOculto: 'Price shown once your business is verified',
    iva0: 'VAT 0%',
    masIva: (p: number) => `+ ${p}% VAT`,
    lote: 'Lot',
    caducidad: 'Expiration',
    caducado: 'Expired',
    caducaPronto: 'Expires soon',
  },
} satisfies Record<IdiomaUI, unknown>

let actual: IdiomaUI = 'es'

export function fijarIdiomaCompartido(idioma: IdiomaUI) {
  actual = idioma
}

/** Textos del idioma vigente. Se lee al dibujar, nunca al cargar el módulo, para que el cambio se note. */
export function tc() {
  return TEXTOS[actual]
}
